import { LogosBaseProps, SimpleWithHeading } from "@/views/blocks/logos/logos";
import logoPlaceholder from "@/views/blocks/shared/images/211x48.svg";
import { computed } from "vue";
import type { BlockDef } from "./block.interfaces";
import { arrayField, createBlock, headingField } from "./blockBuilder";
import { useDefaultColors } from "./useDefaultColors";

export function useLogos() {
    const { colorDefaults } = useDefaultColors();

    const logosBlock = computed<BlockDef>(() =>
        createBlock<LogosBaseProps>({
            typeId: "SimpleWithHeading",
            type: "logos",
            name: "Simple with heading",
            component: SimpleWithHeading,
        })
            .withField("title", headingField("Title", "Trusted by companies worldwide", "h2"))
            .withArrayField(
                "logos",
                arrayField(
                    "Logos",
                    "logos",
                    {
                        src: { label: "Logo", type: "image" },
                        alt: { label: "Alt", type: "text" },
                    },
                    [
                        {
                            src: logoPlaceholder,
                            alt: "Alt 1",
                        },
                        {
                            src: logoPlaceholder,
                            alt: "Alt 2",
                        },
                        {
                            src: logoPlaceholder,
                            alt: "Alt 3",
                        },
                        {
                            src: logoPlaceholder,
                            alt: "Alt 4",
                        },
                        {
                            src: logoPlaceholder,
                            alt: "Alt 5",
                        },
                    ]
                )
            )
            .withStyleFields([colorDefaults.value.background, colorDefaults.value.text])
            .build()
    );

    return {
        blocks: computed(() => [logosBlock.value]),
    };
}
